// Compat: adapta los tipos legacy del frontend (CompanyProfile/Licitacion de @/types)
// al input normalizado del motor de scoring. La lógica pura vive en
// src/lib/scoring/scoring.ts (replicado front/back).
import {
  computeMatch as computeMatchShared,
  levelFromScore,
  levelLabel,
  recommendationLabel,
  type OpportunityScore,
  type ScoringCompanyProfile,
  type ScoringLicitacion,
} from "@/lib/scoring/scoring";
import type { CompanyProfile, LicitacionMock, NivelCualitativo } from "@/types";

/**
 * Tono con que se pinta un nivel cualitativo. Vive junto a `levelLabel` para que
 * la etiqueta y el color salgan del mismo valor: un nivel «sin dato» no es un
 * nivel bajo y no puede llevar su color (ver spec `scoring-oportunidades`).
 */
export type NivelTone = "success" | "warning" | "destructive" | "muted";

export function nivelTone(nivel: NivelCualitativo): NivelTone {
  if (nivel === "alto") return "destructive";
  if (nivel === "medio") return "warning";
  if (nivel === "bajo") return "success";
  return "muted";
}

function toSharedProfile(p: CompanyProfile): ScoringCompanyProfile {
  return {
    datos: {
      rubros: p.datos.rubros,
      keywords: p.datos.keywords,
      regiones: p.datos.regiones,
    },
    historial: p.historial,
    capacidades: p.capacidades,
    estrategia: p.estrategia,
  };
}

function toSharedLicitacion(l: LicitacionMock): ScoringLicitacion {
  return {
    nombre: l.nombre,
    organismo: l.organismo,
    categorias: [l.categoria],
    region: l.region,
    montoEstimado: l.montoEstimado,
    modalidad: l.modalidad,
    riesgo: l.riesgo,
  };
}

export function computeMatch(
  profile: CompanyProfile,
  licitacion: LicitacionMock,
): OpportunityScore {
  return computeMatchShared(toSharedProfile(profile), toSharedLicitacion(licitacion));
}

export { levelFromScore, levelLabel, recommendationLabel };
